<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style1', { sticky: isSticky }]">
      <div class="header-top">
        <div class="container">
          <TopHeader />
        </div>
      </div>
      <MainNavbar />
    </div>
    <div class="content-wrapper">
      <PageBanner pageTitle="Blog Details" mainTitle="Blog Details" />
      <BlogDetails />
    </div>
    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../Layouts/TopHeader.vue";
import MainNavbar from "../Layouts/MainNavbar.vue";
import PageBanner from "../Common/PageBanner.vue";
import BlogDetails from "../BlogDetails/BlogDetails.vue";
import MainFooter from "../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "BlogDetailsPage",
  components: {
    TopHeader,
    MainNavbar,
    PageBanner,
    BlogDetails,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;
      if (scrollPos >= 100) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    });
  },
});
</script>